import { Module, VuexModule, Mutation } from 'vuex-module-decorators'

/**
 * 🧩 Module which handles general caching for the application
 */
@Module
export default class CacheModule extends VuexModule {

  // 📦 The cached data for the "Create bot" page
  public createBotPageCache: any = null;

  /**
  * 👾 Mutation which sets all the data from the create bot page
  */
  @Mutation
  public setCreateBotPageCache(cache: any) {
    this.createBotPageCache = cache;
  }
}

